import {useState} from 'react';

export const useOptionalControls = <T extends {}>(
    /** Initial value for uncontrolled state */
    initialValue: T,
    /** Value for controlled state */
    value?: T,
    /** Controlled state onChange handler */
    onChange: (value: T) => void = () => {}
): [T, (value: T) => void, boolean] => {
    const [uncontrolledValue, setUncontrolledValue] = useState(initialValue);

    if (value !== undefined) {
        return [value, onChange, true];
    }

    const handleUncontrolledChange = (val: T) => {
        setUncontrolledValue(val);
        onChange(val);
    };

    return [uncontrolledValue, handleUncontrolledChange, false];
};
